<mat-form-field
  *ngIf="!readonly"
  floatLabel="always"
  class="w-100"
  [ngClass]="{ 'no-label': hideLabel }"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    type="tel"
    [required]="fgInfo.required"
    matInput
    [placeholder]="placeholder"
    [formControl]="formControl"
    [mask]="phoneMaskConfig?.mask"
    [specialCharacters]="phoneMaskConfig?.specialCharacters"
    [dropSpecialCharacters]="phoneMaskConfig?.dropSpecialCharacters"
    (change)="richChange.emit($event?.target?.value)"
  />
  <mat-hint *ngIf="hasMask && !hint && usePlaceholderAsHint; else noMask">
    {{ placeholder }}
  </mat-hint>
  <ng-template #noMask>
    <mat-hint>{{ hint }}</mat-hint>
  </ng-template>
   <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [floatLabel]="'always'"
    [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
  >
    <mat-label>{{ labelOverride || fgInfo?.label }}</mat-label>
    <input
      type="tel"
      readonly
      matInput
      [placeholder]="placeholder"
      [formControl]="formControl"
      [mask]="phoneMaskConfig?.mask"
      [specialCharacters]="phoneMaskConfig?.specialCharacters"
      [dropSpecialCharacters]="phoneMaskConfig?.dropSpecialCharacters"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
